import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`;

export const StyledBody = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.info.main};
  height: 3rem;
`;
